import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ParagraphDirective } from '../../../shared/directives/paragraph.directive';
import { StandardButtonDirective } from '../../../shared/directives/standard-button.directive';
import { CmsTextPipe } from '../../../pipes/cms-text.pipe';

@Component({
  selector: 'app-redo-test',
  standalone: true,
  imports: [CommonModule, RouterLink, ParagraphDirective, StandardButtonDirective, CmsTextPipe],
  templateUrl: './redo-test.component.html',
  styleUrl: './redo-test.component.scss'
})
export class RedoTestComponent {

}
